document.addEventListener("DOMContentLoaded", function () {
  if (typeof SwatchesConstructor !== "undefined") {
    SwatchesConstructor.prototype.createOptionsView = function (t, e, a, n) {
      // Retrieve product data
      var productData = this.getJsonObject();
      console.log('productData', productData);
      
      // Validate product data
      if (!productData || !productData.options || !productData.variants) {
        console.error("Product data, options, or variants are missing!");
        return;
      }

      var options = productData.options; // Option groups (e.g., Size, Color)
      var variants = productData.variants; // All variants of the product

      // Build HTML for swatches
      var swatchesHtml = '';
      options.forEach(function (option) {
        swatchesHtml += `<div class="tt-title-option">${option.name}</div>`;
        swatchesHtml += '<ul class="custom-swatches">';

        option.values.forEach(function (value) {
          // Check if this option value is available in any variant
          var isAvailable = variants.some(function (variant) {
            return (
              variant.available && // Check if variant is available for purchase
              (variant.option1 === value || variant.option2 === value || variant.option3 === value)
            );
          });

          swatchesHtml += `
            <li class="custom-swatch ${isAvailable ? '' : 'disabled'}" 
                data-option-value="${value}">
              ${value}
            </li>`;
        });

        swatchesHtml += '</ul>';
      });

      // Add hidden input for selected variant ID
      swatchesHtml += `<input type="hidden" name="id" value="" class="variant-input">`;

      // Update the swatches container
      var container = document.querySelector(t);
      if (!container) {
        console.error(`Swatches container not found for selector: ${t}`);
        return;
      }
      container.innerHTML = swatchesHtml;

      // Attach event listeners to swatches
      var swatches = container.querySelectorAll(".custom-swatch");
      var inputHidden = container.querySelector(".variant-input");

      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          // Check if the swatch is disabled
          if (swatch.classList.contains("disabled")) {
            console.warn(`Option "${swatch.getAttribute('data-option-value')}" is unavailable and cannot be selected.`);
            return;
          }

          // Remove 'active' class from all swatches in the same option group
          swatches.forEach((el) => el.classList.remove("active"));

          // Add 'active' class to the clicked swatch
          this.classList.add("active");

          // Get the option value
          const selectedOptionValue = this.getAttribute("data-option-value");
          // Note: Additional logic needed to update variant ID in inputHidden
        });
      });
    };
  } else {
    console.warn("SwatchesConstructor is not defined.");
  }
});